import React from 'react';

import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import FieldCheckbox from '../commons/FieldCheckbox';
import Button from '../commons/Button';
import FieldText from '../commons/FieldText';
import FieldNumber from '../commons/FieldNumber';
import SecurityCard from '../formSections/SecurityCard';

import { emitDocuments, processPayment } from '../../store/forms/form7-actions';

import { makeDataPaymentAndPolicy, getContractingPersonData } from '../../utils/form';

import { getImageURL } from '../../utils/helper-functions';
import { FORM7_VALIDATION_SCHEMA } from '../../constants/validation-schemas';
import termsAndConditionsPDF from '../../assets/pdf/Terminos-y-Condiciones-GS-Autos.pdf';
import usePolicyPDF from '../../assets/pdf/Politica-de-Uso-GS-Autos.pdf';
import privacyStatementPDF from '../../assets/pdf/Aviso-de-Privacidad-GS-Autos.pdf';
import paymentCardsLogo from '../../assets/svg-logos/payment-cards.svg';

const Form7 = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.appConfig.appToken);
  const idProcess = useSelector((state) => state.appConfig.idProcess);
  const form7State = useSelector((state) => state.form7);
  const navigate = useNavigate();
  const currentStep = useSelector((state) => state.appConfig.quoterCurrentStep);
  const quoteId = useSelector(({ form3: { selectedPeriodicity, coverageObject } }) => (
    coverageObject?.forma_pagos[selectedPeriodicity]?.cotizacion?.numeroCotizacion
  ));
  const preferredBeneficiary = useSelector((state) => state.catalogs.preferredBeneficiary);
  const formsData = {
    form2: useSelector((state) => state.form2),
    form3: useSelector((state) => state.form3),
    form4: useSelector((state) => state.form4),
    form5: useSelector((state) => state.form5),
    form6: useSelector((state) => state.form6),
  };
  const isPaid = useSelector((state) => state.form7.isPaid);
  const emissionId = useSelector((state) => state.form6.emissionId);
  const submitHandler = (values) => {
    const data = makeDataPaymentAndPolicy({
      ...formsData,
      form5: getContractingPersonData(formsData.form5, formsData.form4),
      form7: { ...values, preferredBeneficiary: preferredBeneficiary.id },
      quoteId,
    });

    if (!isPaid) {
      dispatch(processPayment(
        token,
        idProcess,
        emissionId,
        values,
        data,
        currentStep,
        navigate,
      ));
    } else {
      dispatch(emitDocuments(
        token,
        idProcess,
        emissionId,
        currentStep,
        navigate,
      ));
    }
  };

  return (
    <Formik
      onSubmit={submitHandler}
      enableReinitialize
      initialValues={form7State}
      validateOnMount={!form7State.wasValidatedBefore}
      validationSchema={Yup.object().shape(FORM7_VALIDATION_SCHEMA)}>
      {({ isValid }) => {
        return (
          <Form className="quoter-form">
            <h2 className="form-title">
              Datos para pago
            </h2>
            <p className="form-subtitle text-center">
              Ingresa los datos de pago para concluir la emisión de la póliza.
            </p>
            <h3 className="no-interest-monthly-title">
              Pago con tarjeta a meses sin intereses
            </h3>
            <div className="payment-cards">
              <h5>Aceptamos las tarjetas</h5>
              <img src={paymentCardsLogo} alt="Tarjetas de pago" />
            </div>
            <hr className="solid" />
            <div className="form-fields short-margin-bottom">
              <div className="field-row">
                <FieldText
                  label="Nombre del titular de la tarjeta"
                  name="cardName"
                  required />
                <FieldNumber
                  label="Número de tarjeta:"
                  required
                  name="cardNumber"
                  maxLength={19} />
              </div>
              <div className="field-row">
                <SecurityCard />
              </div>
            </div>
            <div className="form-fields">
              <div className="field-row">
                <FieldCheckbox name="termsAndPrivacy" required>
                  Acepto&nbsp;
                  <a
                    href={getImageURL(privacyStatementPDF)}
                    target="_blank"
                    className="link-pink"
                    rel="noreferrer">
                    Aviso de Privacidad
                  </a>
                  &nbsp;de General de Seguros
                </FieldCheckbox>
              </div>
              <div className="field-row">
                <FieldCheckbox name="termsAndConditons" required>
                  Aceptar y descargar los&nbsp;
                  <a
                    href={getImageURL(termsAndConditionsPDF)}
                    target="_blank"
                    className="link-pink"
                    rel="noreferrer">
                    términos y condiciones
                  </a>
                  &nbsp;de General de Seguros
                </FieldCheckbox>
              </div>
              <div className="field-row">
                <FieldCheckbox name="termsAndConditonsInsurance" required>
                  Acepto&nbsp;
                  <a
                    href={getImageURL(usePolicyPDF)}
                    target="_blank"
                    className="link-pink"
                    rel="noreferrer">
                    &nbsp;términos y condiciones de este seguro
                  </a>
                </FieldCheckbox>
              </div>
            </div>
            { /** /.form-fields */}
            <div className="form-buttons">
              <Button
                type="submit"
                disabled={!isValid}
                label="Continuar"
                iconClasses="arrow-right" />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default Form7;
